import { useMutation } from "@tanstack/react-query";
import { useAPIClient } from "render/context/APIContext";

export type BarcodeAssignmentMode = "assign" | "reassign";

type Variables = {
  patientId: string;
  visitId: string;
  barcodeId: string;
  mode: BarcodeAssignmentMode;
};

// No global onError handler — the AssignVials view captures every error and
// surfaces it as an inline banner, so routing errors through useReporting
// would also pop a notification on top of the page.
export function useBarcodeAssignmentMutation() {
  const api = useAPIClient();

  return useMutation({
    mutationFn({ patientId, visitId, barcodeId, mode }: Variables) {
      switch (mode) {
        case "assign":
          return api.bloodSample.assignBarcode(
            { patientId },
            { visitId, barcodeId }
          ).result;
        case "reassign":
          return api.bloodSample.reassignBarcode(
            { patientId },
            { visitId, newBarcodeId: barcodeId }
          ).result;
      }
    },
  });
}
